import { render, staticRenderFns } from "./FeaturesPanel.vue?vue&type=template&id=2502fb98&scoped=true&"
import script from "./FeaturesPanel.vue?vue&type=script&lang=js&"
export * from "./FeaturesPanel.vue?vue&type=script&lang=js&"
import style0 from "./FeaturesPanel.vue?vue&type=style&index=0&id=2502fb98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2502fb98",
  null
  
)

export default component.exports